<template>
  <div class="n_list">
    <div class="n_card" v-for="(item,index) in invoiceList" :key="index">
      <div>
        <div class="flex n_card_top">
          <p>订单编号：{{item.chain_order_sn}}</p>
          <p>已完成</p>
        </div>
        <div class="flex order_shop_item">
          <div class="n_checjed">
            <van-checkbox checked-color="#ee0a24" @change="changeFg" v-model="item.checked"></van-checkbox>
          </div>
          <div class="n_pdnum flex">
            <img :src="item.spec_img" alt />
            <div>
              <p class="n_gifName">{{item.goods_name}}</p>
              <div class="order_shop_price">
                <div class="order_specifications">规格:{{item.sku_name}}*{{item.num}}</div>
                <p>
                  <span class="n_fuaho">¥</span>
                  <span class="n_price">{{item.pay_money}}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="n_flex">
          <p class="n_mutic">
            共 {{item.num}} 件商品，实付：
            <span class="n_muticNum">¥{{item.pay_money}}</span>
          </p>
          <div class="flex n_btn_box">
            <p></p>
            <p class="n_btn" @click="applyInvoiceFg(item.id)">申请开票</p>
          </div>
        </div>
      </div>
    </div>
    <div class="invoice-bom" v-if="invoiceList.length > 0">
      <div class="all-checked">
        <van-checkbox checked-color="#ee0a24" @change="allCheckFg" v-model="checked"></van-checkbox>
        <span>全选</span>
      </div>
      <div class="batch-btn" @click="applyInvoiceFg(false)">批量开票</div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
export default {
  props: {
    invoiceList: {
      type: Array,
    },
  },
  data() {
    return {
      checked: false,
    }
  },
  created() {
    this.checked = false
  },
  methods: {
    changeFg() {
      this.checked =
        this.invoiceList.filter((item) => !item.checked).length == 0
    },
    applyInvoiceFg(e) {
      console.log(e)
      let list = ''
      if (!e) {
        let invoiceList = this.invoiceList.filter((item) => {
          return item.checked
        })
        console.log(invoiceList)
        invoiceList.map((item) => {
          list += item.id + ','
        })
      } else {
        list = e
      }
      console.log(list)
      if (list == '') {
        Toast('请先选择需要开票订单')
        return
      }
      this.$router.push({
        path: '/invoiceMachine',
        query: { order_ids: list, type: 0 },
      })
    },
    allCheckFg(e) {
      console.log(e)
      this.$emit('allCheckFg', e)
    },
  },
  computed: {
    ishecked(e) {},
  },
}
</script>

<style lang="scss" scoped>
.n_invoice {
  background: rgba(247, 248, 250, 1);
}
.n_list {
  padding: 20px 20px 120px;
}
.n_invoicesn {
  font-size: 26px;
  color: #333333;
  padding: 0 30px 23px 0;
  border-bottom: 1px solid rgba(238, 238, 238, 1);
}
.n_card {
  background: rgba(255, 255, 255, 1);
  margin-bottom: 20px;
  padding-bottom: 20px;
}
.just_bettw {
  justify-content: space-between;
}
.align_center {
  align-items: center;
}

.n_pdnum {
  margin: 28px 0 20px 0;
}
.n_price {
  font-size: 34px;
  font-weight: 600;
  color: #f0240e;
}
.n_fuaho {
  font-size: 28px;
  font-weight: 600;
  color: #f0240e;
}
.n_redName {
  font-size: 22px;
  color: #f0240e;
}
.n_hui {
  font-size: 24px;
  color: #999999;
}
.n_mutic {
  font-size: 26px;
  color: #343434;
  text-align: right;
  margin-right: 30px;
}
.n_muticNum {
  font-size: 30px;
  color: #333333;
}
.n_mt30 {
  margin-top: 30px;
}
.n_flex {
  flex: 1;
}
.n_checjed {
  margin-right: 26px;
}

.n_card_top {
  box-sizing: border-box;
  font-size: 26px;
  color: #333333;
  line-height: 80px;
  justify-content: space-between;
  border-bottom: 1px solid #eeeeee;
  margin-left: 90px;
  padding-right: 30px;
}
.order_shop_item {
  align-items: center;
  padding: 0 30px;
  img {
    width: 140px;
    height: 140px;
    display: block;
    margin-right: 30px;
    border-radius: 10px;
  }

  .n_gifName {
    font-size: 28px;
    color: #333333;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    width: 420px;
  }

  .order_shop_price {
    display: flex;
    justify-content: space-between;
    margin: 15px 0 10px;
    .order_specifications {
      background: #f2f2f2;
      border-radius: 8px;
      padding: 2px 13px;
      font-size: 24px;
      color: #999999;
      line-height: 33px;
      min-height: 36px;
    }
  }
}
.n_btn_box {
  justify-content: space-between;
  margin-right: 20px;
  .n_btn {
    padding: 12px 40px;
    font-size: 30px;
    color: #ffffff;
    background: #f0240e;
    border-radius: 34px;
    margin-top: 20px;
  }
}

.invoice-bom {
  width: 100%;
  height: 100px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #ffffff;
  position: fixed;
  bottom: 0;
  left: 0;
  box-sizing: border-box;
  padding: 0 30px;
  .all-checked {
    font-size: 24px;
    color: #999999;
    line-height: 24px;
    display: flex;
    align-items: center;
    span {
      margin-left: 22px;
    }
  }
  .batch-btn {
    width: 332px;
    height: 68px;
    background: #ee0a24;
    border-radius: 200px;
    text-align: center;
    line-height: 68px;
    font-size: 28px;
    font-weight: 400;
    color: #ffffff;
  }
}
</style>